import React from "react";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";

import sidebarScrollbar from "../../helpers/sidebarScrollbar";

// Peças visuais dos modais de cadastro (mesmo padrão do modal de contato):
// cabeçalho com título/subtítulo/fechar, seções com título em caixa alta,
// rodapé com "Cancelar" discreto e botão principal.
//
// Uso:
//   const classes = useFormDialogStyles();
//   <Dialog classes={{ paper: classes.paper }} maxWidth="sm" fullWidth>
//     <FormDialogHeader title="…" subtitle="…" onClose={…} />
//     <DialogContent dividers className={classes.content}>
//       <FormSection title="…">…</FormSection>
//     </DialogContent>
//     <DialogActions className={classes.actions}>…</DialogActions>
//   </Dialog>
export const formDialogStyles = (theme) => ({
  paper: {
    borderRadius: 16,
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    padding: theme.spacing(3, 3, 2.5),
  },
  headerText: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.3,
  },
  subtitle: {
    marginTop: 4,
    color: theme.palette.text.secondary,
  },
  closeButton: {
    marginTop: -6,
    marginRight: -8,
    color: theme.palette.text.secondary,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    ...sidebarScrollbar(theme),
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    minHeight: 32,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  muted: {
    color: theme.palette.text.secondary,
  },
  actions: {
    padding: theme.spacing(2, 3),
    gap: theme.spacing(1),
  },
  actionButton: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 10,
    height: 40,
    padding: theme.spacing(0, 2.5),
  },
  cancelButton: {
    color: theme.palette.text.primary,
  },
  secondaryButton: {
    color: theme.palette.text.primary,
    borderColor: theme.palette.divider,
  },
  textButton: {
    textTransform: "none",
    fontWeight: 600,
  },
  progressWrapper: {
    position: "relative",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
});

export const useFormDialogStyles = makeStyles(formDialogStyles);

export const FormDialogHeader = ({ id, title, subtitle, onClose, disabled }) => {
  const classes = useFormDialogStyles();
  return (
    <div className={classes.header}>
      <div className={classes.headerText}>
        <Typography id={id} component="h2" className={classes.title}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" className={classes.subtitle}>
            {subtitle}
          </Typography>
        )}
      </div>
      {onClose && (
        <IconButton
          className={classes.closeButton}
          onClick={onClose}
          aria-label="Fechar"
          disabled={disabled}
        >
          <CloseIcon />
        </IconButton>
      )}
    </div>
  );
};

export const FormSection = ({ title, action, children }) => {
  const classes = useFormDialogStyles();
  return (
    <section className={classes.section}>
      {(title || action) && (
        <div className={classes.sectionHeader}>
          <Typography component="h3" className={classes.sectionTitle}>
            {title}
          </Typography>
          {action}
        </div>
      )}
      {children}
    </section>
  );
};
